import { Component, OnInit, Inject } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DialogComponent } from 'src/app/dialog.component';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-status-modal',
    templateUrl: './status-modal.component.html'
})
export class StatusModalComponent implements OnInit {
    savingFlag: boolean = false;
    segment: any = {};
    category: any = {};
    notAcceptable: boolean = false;
    notacceptable: boolean = false;
    
    login: any = {};
    delivery_from: any;
    userData: any;
    userId: any;
    userName: any;
    salesUser: any = [];
    assignDistArray: any = [];
    couponArray: any = [];
    drlist: any = [];
    segmentList: any = [];
    urls: any = [];
    image_url: any;
    loader: any; lr_docs: any = []
    material_docs: any = []
    invoice_document: any = []
    selectedFile: any = [];
    image_id: any;
    pageCount;
    invoiceId: any;
    totalListingCount: any;
    subCategory: any = [];
    organisationData: any = [];
    companyAccount: any;
    companyId: any;
    skLoading: boolean = false;
    elementType: any = ''
    today_date: any;
    getData: any = []
    product_id: any;
    product_level_data: any = [];
    
    constructor(@Inject(MAT_DIALOG_DATA) public data, public alert: DialogComponent, public service: DatabaseService, public dialog: MatDialog, public serve: DatabaseService, public session: sessionStorage, public toast: ToastrManager, public route: ActivatedRoute, public rout: Router, public dialogRef: MatDialogRef<StatusModalComponent>) {
        this.userData = JSON.parse(localStorage.getItem('st_user'));
        this.segment = this.data.segment;
        this.userId = this.userData['data']['id'];
        this.userName = this.userData['data']['name'];
        this.delivery_from = this.data.delivery_from;
        console.log(this.delivery_from)
        
        if (this.data['from'] == 'upload_invoice_image') {
            console.log('from = upload_invoice_image');
            this.invoiceId = this.data['invoiceData']['id'];
            this.invoice_document = this.data['invoiceData']['images'];
            for (let i = 0; i < this.invoice_document.length; i++) {
                if (this.invoice_document[i].type == 'Material') {
                    this.material_docs.push({ 'image': this.invoice_document[i].image, 'type': this.invoice_document[i].type, 'id': this.invoice_document[i].id });
                    
                }
                else {
                    this.lr_docs.push({ 'image': this.invoice_document[i].image, 'type': this.invoice_document[i].type, 'id': this.invoice_document[i].id });
                }
            }
            console.log(this.invoiceId);
            console.log(this.invoice_document);
            console.log(this.material_docs);
            console.log(this.lr_docs);
        }
        
        console.log(data);
        console.log(this.data);
        
        this.image_url = service.uploadUrl + 'invoice/'
        console.log(this.image_url);
        
        if (data.from == 'primary_order' && data.order_status == 'Approved') {
            this.getCompanyData()
        }
    }
    
    ngOnInit() {
        
        if (this.delivery_from == 'assignDist') {
            this.distributorDetail();
            this.distributorList('', this.data.state)
            
        } else if (this.delivery_from == 'assignSales') {
            this.distributorDetail();
            this.getSalesUser('')
        }
        else if (this.delivery_from == 'subcategory-list') {
            this.data.segment_id = this.data.master_category_id.toString();
            this.getSegment();
            this.getSegmentList();
        }
        else if (this.delivery_from == 'edit_travel_plan_retailer') {
            this.data.employee_id = this.data.employee_id.toString();
            this.data.id = this.data.travel_plan_id.toString();
            this.data.distributor_id = this.data.drId.toString();
            this.allCustomerNetworkList('');
        }
        else if (this.delivery_from == 'product_list_page') {
            this.getProduct('')
            
        }
        else if (this.delivery_from == 'product_list_qr') {
            this.getProduct('')
            
        }
        else if (this.delivery_from == 'product-list') {
            console.log('assign level')
            this.getLevel('')
            console.log(this.data.product_id, 'id')
            this.getProductDetail()
        }
        
        this.login = JSON.parse(localStorage.getItem('login'));
    }
    
    checkValue(qty) {
        this.notAcceptable = false;
        console.log(this.notAcceptable);
        
        console.log('In Function');
        console.log(qty, this.data.count);
        
        if (qty > this.data.count) {
            this.notAcceptable = true;
            console.log('In If');
        }
        else {
            console.log('In Else');
        }
    }
    checkSequence(value) {
        this.notacceptable = false;
        console.log(this.notacceptable);
        
        console.log('In Function');
        console.log(value, this.data.pageCount);
        
        if (value > this.data.pageCount) {
            this.notacceptable = true;
            console.log('In If');
        }
        else {
            console.log('In Else');
        }
    }
    
    downloadLogReport() {
        console.log('download log report')
        this.savingFlag = true;
        this.data.date_from ? (this.data.date_from = moment(this.data.date_from).format('YYYY-MM-DD')) : null;
        this.data.date_to ? (this.data.date_to = moment(this.data.date_to).format('YYYY-MM-DD')) : null;
        let apiName = '';
        if (this.delivery_from == 'log_report') {
            apiName = "Excel/IntegrationLogsCsv"
        }
        this.serve.post_rqst({ "date_from": this.data.date_from, "date_to": this.data.date_to }, apiName).subscribe((result: any) => {
            if (result['statusCode'] == 200) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg']);
                
            }
        }, () => { this.savingFlag = false; this.toast.errorToastr('Something went wrong'); })
    }
    
    getCompanyData() {
        this.serve.post_rqst({}, "Order/organizationName").subscribe((response => {
            if (response['statusCode'] == 200) {
                this.organisationData = response['result'];
                
                
            }
            else {
                this.toast.errorToastr(response['statusMsg']);
            }
            
        }));
    }
    findCode(orgId) {
        let index = this.organisationData.findIndex(row => row.orgId == orgId)
        if (index != -1) {
            this.companyAccount = this.organisationData[index].orgCode;
            console.log(this.companyAccount)
        }
    }
    reason_reject: any
    primary_order_status_change(reason, status) {
        console.log(this.data.organisation_id);
        console.log(this.companyAccount)
        this.savingFlag = true;
        this.serve.post_rqst({ 'reason': reason, 'status': status, 'id': this.data.order_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName, 'orgId': this.data.organisation_id, 'orgCode': this.companyAccount }, "Order/primaryOrderStatusChange").subscribe((result => {
            
            
            if (result['statusCode'] == 200) {
                
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
            
        }))
        
    }
    
    
    secondary_order_status_change(reason, status) {
        this.savingFlag = true;
        this.serve.post_rqst({ 'reason': reason, 'status': status, 'id': this.data.order_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Order/secondaryOrderStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }
    
    getSalesUser(searcValue) {
        this.serve.post_rqst({ 'search': searcValue }, "CustomerNetwork/salesUserList").subscribe((response => {
            if (response['statusCode'] == 200) {
                this.salesUser = response['all_sales_user'];
            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
            
        }));
    }
    distributorDetail() {
        let id = { "id": this.data.drId }
        this.serve.post_rqst(id, "CustomerNetwork/distributorDetail").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.data = result['distributor_detail'];
                this.data.id = result['distributor_detail']['id'];
                this.data.assigned_sales_user_name = this.data['assigned_sales_user_name'].map(String);
                let newArr = this.data['distributors'];
                console.log(newArr)
            }
            else {
                this.toast.errorToastr(result['statusMsg'])
            }
        }
    )
}
distributorList(searcValue, state) {
    this.serve.post_rqst({ 'search': searcValue, 'state': state }, "CustomerNetwork/distributorsList").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.drlist = result['distributors'];
        } else {
            this.toast.errorToastr(result['statusMsg']);
        }
    }))
}

allCustomerNetworkList(searcValue) {
    this.drlist = [];
    this.serve.post_rqst({ 'search': searcValue, 'type': this.data.drType, 'employee_id': this.data.employee_id }, "Travel/drList").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.drlist = result['result'];
        } else {
            this.toast.errorToastr(result['statusMsg']);
        }
    }))
}


getSegment() {
    this.serve.post_rqst({}, "Master/getProductCategoryList").subscribe((result => {
        if (result['category_list']['statusCode'] == 200) {
            this.segmentList = result['category_list']['segment_list'];
        }
        else {
            this.savingFlag = false;
            this.toast.errorToastr(result['category_list']['statusCode'])
        }
    }))
}
getSegmentList() {
    this.serve.post_rqst({}, "Master/getSubCategoryList").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.subCategory = result.sub_category_list.sub_cat_list;
            this.pageCount = result.sub_category_list.sub_cat_count;
        }
        else {
            this.toast.errorToastr(result['category_list']['statusCode'])
        }
    }))
}

UpdateSalesUser() {
    this.savingFlag = true;
    setTimeout(() => {
        this.serve.post_rqst({ 'drId': this.data.id, 'userArray': this.data.assigned_sales_user_name, 'company_name': this.data.company_name }, "CustomerNetwork/drUserAssign").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }, 2000);
}
// distArray(data){
//   this.assignDistArray = []
//   let index = this.drlist.findIndex(row => row.id == data)
//   if(index != -1){
//     this.assignDistArray.push(this.drlist[index].id)
//   }
// }
UpdateDistributor() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'drId': this.data.id, 'distributorId': this.data.distributor_id }, "CustomerNetwork/dealerDistributorAssign").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.dialog.closeAll();
            this.savingFlag = false;
            this.toast.successToastr(result['statusMsg']);
        }
        else {
            this.savingFlag = false;
            this.toast.errorToastr(result['statusMsg'])
        }
    }))
}
UpdateCustomerNetworkTravel() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'id': this.data.id, 'dr_id': this.data.distributor_id }, "Travel/drChange").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.dialog.closeAll();
            this.savingFlag = false;
            this.toast.successToastr(result['statusMsg']);
        }
        else {
            this.savingFlag = false;
            this.toast.errorToastr(result['statusMsg'])
        }
    }))
}

add_segment() {
    this.savingFlag = true;
    this.data.created_by_name = this.userName;
    this.data.created_by_id = this.userId;
    this.serve.post_rqst(this.data, "Master/addCategory").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.toast.successToastr(result['statusMsg']);
            this.savingFlag = false;
            this.dialogRef.close(true)
            this.serve.count_list();
        }
        else {
            this.toast.errorToastr(result['statusMsg']);
            this.savingFlag = false;
        }
        
    }))
    
}
add_subCategory() {
    this.savingFlag = true;
    this.data.created_by_name = this.userName;
    this.data.created_by_id = this.userId;
    this.serve.post_rqst(this.data, "Master/addSubCategory").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.toast.successToastr(result['statusMsg']);
            this.savingFlag = false;
            this.dialogRef.close(true)
            this.serve.count_list();
        }
        else {
            this.toast.errorToastr(result['statusMsg']);
            this.savingFlag = false;
        }
        
    }))
    
}

saveinvoice_detailImage(image, upload_type) {
    console.log(image, upload_type);
    this.savingFlag = true;
    
    this.service.post_rqst({ 'invoiceId': this.invoiceId, 'invoiceImages': this.urls, 'upload_type': upload_type }, "Account/invoiceImages").subscribe(result => {
        if (result['statusCode'] == 200) {
            this.toast.successToastr('Image Save Successfully');
            this.savingFlag = false;
            this.urls = [];
            this.dialogRef.close(true);
        } else {
            this.dialogRef.close(true);
            this.toast.errorToastr(result['statusMsg']);
        }
    }, err => {
        this.toast.errorToastr('Something went wrong');
        
    })
}

delete_img(index: any) {
    this.urls.splice(index, 1)
    this.selectedFile = [];
    
}

delete_Savedimg(id, index) {
    this.alert.confirm('Are you Sure you want to delete this image?').then((result) => {
        if (result) {
            this.service.post_rqst({ 'invoiceId': this.invoiceId, 'invoiceImageId': id, }, "Account/deleteImages").subscribe(result => {
                if (result['statusCode'] == 200) {
                    this.dialogRef.close(true);
                } else {
                    this.dialogRef.close(true);
                    this.toast.errorToastr(result['statusMsg']);
                }
            }, err => {
                this.loader = false;
            })
        }
        else {
            this.loader = false;
            
        }
    })
    
}

insertImage(event) {
    let files = event.target.files;
    this.image_id = '';
    
    if (files) {
        for (let file of files) {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.urls.push(e.target.result);
            }
            reader.readAsDataURL(file);
        }
    }
    for (var i = 0; i < event.target.files.length; i++) {
        this.selectedFile.push(event.target.files[i]);
    }
}
// product List  Start For print coupon code
product_data = [];

filter: any = {};
getProduct(searcValue) {
    this.filter.product_name = searcValue;
    this.filter.check_coupon = 'generated';
    this.service.post_rqst({ 'filter': this.filter }, 'Master/productList').subscribe((resp) => {
        if (resp['statusCode'] == 200) {
            this.product_data = resp['product_list'];
            
        }
        else {
            this.toast.errorToastr(resp['statusMsg']);
        }
    }, error => {
    })
    
}





getLevel(searcValue) {
    this.filter = searcValue;
    this.service.post_rqst({ 'filter': this.filter }, 'Master/getLevel').subscribe((resp) => {
        if (resp['statusCode'] == 200) {
            this.product_level_data = resp['result'];
        }
        else {
            this.toast.errorToastr(resp['statusMsg']);
        }
    }, error => {
    })
}



assignLeveltoProduct() {
    this.service.post_rqst({ 'data': this.data }, 'Master/assignLevelToProduct').subscribe((resp) => {
        if (resp['statusCode'] == 200) {
            this.toast.successToastr(resp['statusMsg']);
            this.dialogRef.close(true);
        }
        else {
            this.dialogRef.close(true);
            this.toast.errorToastr(resp['statusMsg']);
        }
    }, error => {
    })
}

getProductDetail() {
    this.skLoading = true;
    this.service.post_rqst({ 'product_id': this.data.product_id }, "Master/productDetail").subscribe((result => {
        this.getData = result['product_detail'];
        const levels = result['product_detail']['level'];
        const extractedValues = [];
        levels.forEach(level => {
            extractedValues.push(level.level);
        });
        console.log('Extracted Product Levels:', extractedValues);
        this.data.product_level = extractedValues.map(String);
        
        console.log('Fetched Product Levels:', this.data.product_level)
        this.skLoading = false;
    }
));

}


product: any = []
product_code: any;
coupon_code: any;
findProductId(id) {
    console.log(id);
    this.product = [];
    for (let i = 0; i < id.length; i++) {
        let index = this.product_data.findIndex(row => row.id == id[i])
        console.log(index);
        
        if (index != -1) {
            this.product.push({ 'product_id': this.product_data[index].id, 'coupon_code': this.product_data[index].coupon_code, 'product_code': this.product_data[index].product_code })
            
        }
        console.log(this.product);
    }
    
}

allSelect(type) {
    if (type == "product") {
        setTimeout(() => {
            if (this.data.checkproduct == true) {
                const array = [];
                for (let i = 0; i < this.product_data.length; i++) {
                    array.push(this.product_data[i].id);
                }
                this.data.product_id = array.map(String);
                this.findProductId(this.data.product_id)
            }
            else {
                this.data.product_id = '';
            }
            
        }, 50);
    }
}

selectedProduct() {
    
    this.printData()
    this.dialogRef.close(true);
    
    
    
}

printData(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print_card').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    
    popupWin.document.write(`
    <html>
    <head>
    <title>Print tab</title>
    <style>
    @media print {
        #qr_code_container  {
            page-break-inside: always;
            margin-bottom: 0px
        }
        @page { 
            margin: 0.00in 0.00in  0.00in 0.00in;  
        }
        
        .qr_img{
            position: relative;
            text-align: center;
            font-size: 0.5rem
        }
        .qr_img span {
            position: absolute;
            left: 0;
            z-index: 1;
        }
        .qr_img ngx-qrcode, .aclass{
            width: 94.488188976px !important;
            height: 94.488188976px !important;
            text-align: center;
            position: relative;
        }
        
        
        
        span.fix-text {
            position: absolute;
            left: -20px;
            top: 30px;
            transform: rotate(-90deg);
            font-weight: bold;
            font-size: 14px;
            width: 60px;
            height: 20px;
            display: flex;
            justify-content: center;
        }
        
        span.fix-text-code{
            position: absolute;
            top: 33px;
            left: -20px;
            transform: rotate(-90deg);
            font-weight: bold;
            font-size: 8px;
            height: 15px;
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        span.fix-text-right {
            position: absolute;
            left: 58px;
            top: 30px;
            transform: rotate(-90deg);
            font-weight: bold;
            font-size: 10px;
            width: 60px;
            height: 20px;
            display: flex;
            justify-content: center;
        }
        
        span.fix-code {
            position: absolute;
            bottom: 8px;
            font-size: 7px;
            width: 100%;
        }
        .qr_img img{
            width: 82px !important;
            height: 82px !important;
        }
        
        
        
        .qr-codes {
            position: relative;
        }
        .qr-codes span{
            position: absolute;
            font-size: 10px;
            bottom: -2px;
            text-align: center;
            width: 100%;
            left:50%;
            transform:translateX(-50%);
        }
        
        
        
        body
        {
            font-family: 'arial';
        }
        </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
        </html>`
    );
    
    popupWin.document.close();
}

submitQR() {
    console.log(this.data.description);    
    this.savingFlag = true;
    this.service.post_rqst({ 'data': this.data }, 'Master/genrateCoupons').subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
        this.rout.navigate(['productComponentQR/']);
        this.savingFlag = false;
        this.data = {};
        this.dialogRef.close(true);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    })
}

// printData(): void {
//     let printContents, popupWin;
//     printContents = document.getElementById('print_card').innerHTML;
//     popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
//     popupWin.document.open();

//     popupWin.document.write(`
// <html>
// <head>
// <title>Print tab</title>
// <style>
// @media print {
//   #qr_code_container  {
//     page-break-inside: always;
//     margin-bottom: 0px
//   }
//   @page { 
//     margin: 0.00in 0.00in  0.00in 0.00in;  
//   }

//   .qr_img{
//     position: relative;
//     text-align: center;
//     font-size: 0.5rem
//   }
//   .qr_img span {
//     position: absolute;
//     left: 0;
//     z-index: 1;
//   }
//   .qr_img ngx-qrcode, .aclass{
//     width: 94.488188976px !important;
//     height: 94.488188976px !important;
//     text-align: center;
//     position: relative;
//   }



//   span.fix-text {
//     position: absolute;
//     left: -20px;
//     top: 30px;
//     transform: rotate(-90deg);
//     font-weight: bold;
//     font-size: 14px;
//     width: 60px;
//     height: 20px;
//     display: flex;
//     justify-content: center;
//   }

//   span.fix-text-code{
//     position: absolute;
//     top: 33px;
//     left: -20px;
//     transform: rotate(-90deg);
//     font-weight: bold;
//     font-size: 8px;
//     height: 15px;
//     width: 60px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   span.fix-text-right {
//     position: absolute;
//     left: 58px;
//     top: 30px;
//     transform: rotate(-90deg);
//     font-weight: bold;
//     font-size: 10px;
//     width: 60px;
//     height: 20px;
//     display: flex;
//     justify-content: center;
//   }

//   span.fix-code {
//     position: absolute;
//     bottom: 8px;
//     font-size: 7px;
//     width: 100%;
//   }
//   .qr_img img{
//     width: 82px !important;
//     height: 82px !important;
//   }



//   .qr-codes {
//     position: relative;
//   }
//   .qr-codes span{
//     position: absolute;
//     font-size: 10px;
//     bottom: -2px;
//     text-align: center;
//     width: 100%;
//     left:50%;
//     transform:translateX(-50%);
//   }



//   body
//   {
//     font-family: 'arial';
//   }
//   </style>
//   </head>
//   <body onload="window.print();window.close()">${printContents}</body>
//   </html>`
//     );

//     popupWin.document.close();
// }

// product List End For print coupon code


}
